import { graphql, useStaticQuery } from 'gatsby'

const allContentfulComponentFeaturedSlider = () => {
  return useStaticQuery(graphql`
    {
      allContentfulComponentFeaturedSlider(filter: { node_locale: { eq: "en-US" } }) {
        edges {
          node {
            id
            name
            node_locale
            title
            subtitle
            publishDate
            unpublishDate
            alignment
            cta {
              ... on ContentfulTopicCta {
                name
                externalUrl
              }
            }
            targetedLinks {
              name
              targetedPages {
                name
                slug
              }
            }
          }
        }
      }
    }
  `)
}

export default { allContentfulComponentFeaturedSlider }
